import { render } from "./LandingComp.vue?vue&type=template&id=617668a4&scoped=true&ts=true"
import script from "./LandingComp.vue?vue&type=script&lang=ts"
export * from "./LandingComp.vue?vue&type=script&lang=ts"

import "./LandingComp.vue?vue&type=style&index=0&id=617668a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617668a4"]])

export default __exports__